__turbopack_context__.v({
  "container": "container-module___qYO5W__container",
  "full": "container-module___qYO5W__full",
  "lg": "container-module___qYO5W__lg",
  "md": "container-module___qYO5W__md",
  "sm": "container-module___qYO5W__sm",
});
